import React from "react";
import {
  makeStyles,
  tokens,
  Card,
  Text,
  Button,
} from "@fluentui/react-components";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import Logo from "../components/Logo";

const useStyles = makeStyles({
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: tokens.colorNeutralBackground2,
    padding: tokens.spacingVerticalXL,
  },
  loginCard: {
    maxWidth: "400px",
    width: "100%",
    padding: tokens.spacingVerticalXXL,
    textAlign: "center",
  },
  logo: {
    marginBottom: tokens.spacingVerticalXL,
  },
  title: {
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: tokens.spacingVerticalM,
    display: "flex",
    justifyContent: "center",
  },
  subtitle: {
    color: tokens.colorNeutralForeground2,
    marginBottom: tokens.spacingVerticalXXL,
    display: "flex",
    justifyContent: "center",
  },
  signInButton: {
    minWidth: "200px",
  },
  logoImage: {
    height: "40px",
    marginBottom: tokens.spacingVerticalM,
    color: tokens.colorBrandBackground,
  },
});

const LoginPage: React.FC = () => {
  const { instance } = useMsal();
  const styles = useStyles();

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className={styles.container}>
      <Card className={styles.loginCard}>
        <div className={styles.logo}>
          <Logo className={styles.logoImage} />
        </div>
        <Text className={styles.title}>Purchase Approval System</Text>
        <Text className={styles.subtitle}>
          Sign in with your Microsoft account to access the purchase approval
          system
        </Text>
        <Button
          appearance="primary"
          size="large"
          className={styles.signInButton}
          onClick={handleLogin}
        >
          Sign in with Microsoft
        </Button>
      </Card>
    </div>
  );
};

export default LoginPage;
